import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const PlanningStateSpaceSearch = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Planning as State-space search, Forward search, backward search"
    videos={[
      "https://www.youtube.com/embed/_xQ0Jt-kbjo",
      "https://www.youtube.com/embed/3bLyGmI9vLM"
    ]}
    takeaways={[]}
    questions={[
      "Discuss how forward state space search differs from backward state space search. Explain in detail.",
      "Consider a maze with the following layout: Here • is the robot, G is the goal where the robot has to reach, white blocks are open and the shaded blocks are walls. The robot can move one step at a time. Compare and contrast forward search and backward search algorithms for solving this maze navigation problem. Write every step. Discuss the advantages and disadvantages of each approach."
    ]}
    exampleVideos={[]}
  />
);
}

export default PlanningStateSpaceSearch;
